import { statePrefixOf } from "./statePrefix";

/**
 * Extracts the US state code from a SubmissionType enum value.
 *
 * Most submission types are prefixed with a 2-letter state code
 * (e.g. `KS_ANNUAL_REPORT` → `"KS"`, `CA_EVQ` → `"CA"`).
 *
 * Returns `null` for types that are not state-specific (e.g. `OTHER`,
 * `ANNUAL_REPORT`, `BIENNIAL_REPORT`, `WASTE_BIENNIAL`,
 * `HAZARDOUS_WASTE_NOTIFICATION`, `EXCEPTION_REPORT`).
 */
export function getStateForSubmissionType(submissionType: string): string | null {
  return statePrefixOf(submissionType);
}
